import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/** Placeholder de la vue QR-Code des visites. Montee sous qrcode/:tenant/:pos pour garder l'URL finale. */
@Component({
  selector: 'app-qr-visit-wip',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './qr-visit-wip.component.html'
})
export class QrVisitWipComponent {
  private readonly route = inject(ActivatedRoute);

  readonly clientId = this.route.snapshot.paramMap.get('tenant') ?? '';
  readonly posId = this.route.snapshot.paramMap.get('pos') ?? '';

  closeTab(): void {
    window.close();
  }
}
